import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

type PolicyKind = 'terms' | 'privacy' | 'disclaimer' | 'cookies' | 'refund';

const POLICY_LAST_UPDATED: Record<PolicyKind, string> = {
  terms: 'December 2, 2025',
  privacy: 'December 2, 2024',
  disclaimer: 'December 2, 2025',
  cookies: 'December 2, 2025',
  refund: 'December 2, 2025'
};

@Component({
  selector: 'app-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './policy.component.html',
  styleUrl: './policy.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PolicyComponent {
  private readonly route = inject(ActivatedRoute);

  readonly policyKind = toSignal(
    this.route.data.pipe(
      map((data) => (data['policyKind'] as PolicyKind | undefined) ?? 'terms')
    ),
    { initialValue: 'terms' as PolicyKind }
  );

  readonly lastUpdated = computed(() => POLICY_LAST_UPDATED[this.policyKind()]);
}
